/**
 * Utility functions for validating material compatibility between Column Material and Shaft Material
 */

/**
 * Business rules for material matching:
 * - Mild Steel (STD) Column → 416SS Shaft
 * - 316 SS Column → 316SS Shaft
 * - 304 SS Column → 17-4 PH Shaft
 */
const MATERIAL_MATCH_RULES = {
  'Mild Steel (STD)': '416SS',
  '316 SS': '316SS',
  '304 SS': '17-4 PH',
};

/**
 * Check if column material and shaft material match according to business rules
 * @param {string} columnMaterial - The column material value
 * @param {string} shaftMaterial - The shaft material value
 * @returns {Object} Validation result with hasMismatch and expectedValue
 */
export const checkMaterialMismatch = (columnMaterial, shaftMaterial) => {
  // If either value is empty/null, don't validate
  if (!columnMaterial || !shaftMaterial) {
    return {
      hasMismatch: false,
      expectedShaftMaterial: null,
      actualShaftMaterial: shaftMaterial,
      columnMaterial: columnMaterial,
    };
  }

  const expectedShaftMaterial = MATERIAL_MATCH_RULES[columnMaterial];

  // If no rule exists for this column material, don't validate
  if (!expectedShaftMaterial) {
    return {
      hasMismatch: false,
      expectedShaftMaterial: null,
      actualShaftMaterial: shaftMaterial,
      columnMaterial: columnMaterial,
    };
  }

  // Check if shaft material matches expected value
  const hasMismatch = shaftMaterial !== expectedShaftMaterial;

  return {
    hasMismatch,
    expectedShaftMaterial,
    actualShaftMaterial: shaftMaterial,
    columnMaterial,
  };
};

/**
 * Get material mismatch data for a specific zone
 * @param {Object} pumpManifoldData - PumpManifoldPiping data
 * @param {Array} pumpDetails - Array of pump detail objects
 * @returns {Object} Mismatch validation result
 */
export const getMaterialMismatchData = (pumpManifoldData, pumpDetails) => {
  const columnMaterial = pumpManifoldData?.ColumnMaterialVT;
  
  // Get shaft material from first main pump (they should all match)
  const shaftMaterial = pumpDetails && pumpDetails.length > 0 
    ? pumpDetails[0]?.MainShaftMaterial 
    : null;

  return checkMaterialMismatch(columnMaterial, shaftMaterial);
};
